import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { Bank } from 'phosphor-react';

import { ImportarExtratoContent } from './ImportarExtratoContent';

interface ImportarExtratoModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialFiltro?: 'recentes' | 'pendentes';
}

/**
 * Modal glass (visionOS) de importacao de extrato. Overlay com blur +
 * ModalContent translucido. Reusa ImportarExtratoContent.
 */
export function ImportarExtratoModal({
  isOpen,
  onClose,
  initialFiltro,
}: ImportarExtratoModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={{ base: 'full', md: 'xl' }}
      isCentered
      scrollBehavior="inside"
      motionPreset="slideInBottom"
    >
      <ModalOverlay
        bg="rgba(15, 23, 42, 0.45)"
        backdropFilter="blur(8px)"
        sx={{ WebkitBackdropFilter: 'blur(8px)' }}
      />
      <ModalContent
        bg="rgba(255, 255, 255, 0.82)"
        backdropFilter="blur(40px) saturate(200%)"
        sx={{ WebkitBackdropFilter: 'blur(40px) saturate(200%)' }}
        borderWidth="1px"
        borderColor="rgba(255, 255, 255, 0.6)"
        borderRadius={{ base: 'none', md: '3xl' }}
        boxShadow="0 1px 0 0 rgba(255,255,255,0.9) inset, 0 24px 70px -18px rgba(27, 136, 245, 0.30), 0 8px 24px -8px rgba(15, 23, 42, 0.12)"
        maxH={{ base: '100dvh', md: '88vh' }}
        overflow="hidden"
      >
        <ModalHeader pt={5} pb={2}>
          <Flex align="center" gap={3}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              w="44px"
              h="44px"
              borderRadius="xl"
              bg="linear-gradient(135deg, #E0E7FF 0%, #DDD6FE 100%)"
              color="#6366F1"
              flexShrink={0}
            >
              <Bank size={24} weight="duotone" />
            </Box>
            <Box>
              <Heading fontSize="lg" fontWeight="700" color="#0F172A" lineHeight="1.2">
                Importar extrato
              </Heading>
              <Text fontSize="xs" color="#64748B">
                Categorização automática + vínculo ao Plano de Contas
              </Text>
            </Box>
          </Flex>
        </ModalHeader>
        <ModalCloseButton top={4} color="#64748B" />

        <ModalBody pb={6} pt={2}>
          <ImportarExtratoContent initialFiltro={initialFiltro} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
